export default __webpack_public_path__ + "static/media/member3.bc966566.jpg";